package com.karyadina.service

import com.karyadina.model.*
import com.karyadina.model.Unit as StudyUnit

/**
 * Storage interface for flashcard data
 */
interface FlashcardStorage {
    // Subjects
    fun saveSubjects(subjects: List<FlashCard_Subject>)
    fun loadSubjects(): List<FlashCard_Subject>
    
    // Units
    fun saveUnits(units: List<StudyUnit>)
    fun loadUnits(): List<StudyUnit>
    
    // Flashcards
    fun saveFlashcards(cards: List<Flashcard>)
    fun loadFlashcards(): List<Flashcard>
    
    // Review sessions
    fun saveSessions(sessions: List<ReviewSession>)
    fun loadSessions(): List<ReviewSession>
    
    // Statistics
    fun saveStats(stats: FlashcardStats)
    fun loadStats(): FlashcardStats?
}

/**
 * Implementation using generic KeyValueStorage
 */
class FlashcardStorageImpl(
    private val storage: KeyValueStorage = AppStorage.get()
) : FlashcardStorage {
    
    companion object {
        private const val KEY_SUBJECTS = "flashcard_subjects"
        private const val KEY_UNITS = "flashcard_units"
        private const val KEY_CARDS = "flashcard_cards"
        private const val KEY_SESSIONS = "flashcard_sessions"
        private const val KEY_STATS = "flashcard_stats"
    }
    
    override fun saveSubjects(subjects: List<FlashCard_Subject>) {
        storage.saveJson(KEY_SUBJECTS, subjects)
    }
    
    override fun loadSubjects(): List<FlashCard_Subject> {
        return storage.loadJson<List<FlashCard_Subject>>(KEY_SUBJECTS) ?: emptyList()
    }
    
    override fun saveUnits(units: List<StudyUnit>) {
        storage.saveJson(KEY_UNITS, units)
    }
    
    override fun loadUnits(): List<StudyUnit> {
        return storage.loadJson<List<StudyUnit>>(KEY_UNITS) ?: emptyList()
    }
    
    override fun saveFlashcards(cards: List<Flashcard>) {
        storage.saveJson(KEY_CARDS, cards)
    }
    
    override fun loadFlashcards(): List<Flashcard> {
        return storage.loadJson<List<Flashcard>>(KEY_CARDS) ?: emptyList()
    }
    
    override fun saveSessions(sessions: List<ReviewSession>) {
        storage.saveJson(KEY_SESSIONS, sessions)
    }
    
    override fun loadSessions(): List<ReviewSession> {
        return storage.loadJson<List<ReviewSession>>(KEY_SESSIONS) ?: emptyList()
    }
    
    override fun saveStats(stats: FlashcardStats) {
        storage.saveJson(KEY_STATS, stats)
    }
    
    override fun loadStats(): FlashcardStats? {
        return storage.loadJson<FlashcardStats>(KEY_STATS)
    }
}
